import { useEffect, useRef } from "react";
import { useAnalytics } from "./useAnalytics";
export var useSendScreenEvent = function (payload, isVisble) {
    if (isVisble === void 0) { isVisble = true; }
    var sendScreenEvent = useAnalytics().sendScreenEvent;
    var sendScreenEventRef = useRef(sendScreenEvent);
    var payloadRef = useRef(payload);
    useEffect(function () {
        sendScreenEventRef.current = sendScreenEvent;
    }, [sendScreenEvent]);
    useEffect(function () {
        payloadRef.current = payload;
    }, [payload]);
    useEffect(function () {
        if (isVisble) {
            var payloadFormatted = typeof payloadRef.current === "string"
                ? { name: payloadRef.current }
                : payloadRef.current;
            sendScreenEventRef.current(payloadFormatted);
        }
    }, [isVisble]);
};
